import React from 'react';

import { FiltrosContainer, BotaoFiltro, BotoesContainer } from './styles';

const FiltrosSolicitacoes = ({ setFiltroPorStatus, filtroPorStatus, tema }) => {
  let btnAtivo = {
    color: tema?.primaryColor,
    borderBottom: `3px solid ${tema?.primaryColor}`,
  };

  let btnInativo = {
    color: '#444444',
    borderBottom: '3px solid #848484',
  };

  return (
    <FiltrosContainer>
      <span>Filtrar solicitações por status:</span>
      <BotoesContainer>
        <BotaoFiltro
          onClick={() => setFiltroPorStatus(['Todos'])}
          style={
            filtroPorStatus.includes('Todos')
              ? { ...btnAtivo }
              : { ...btnInativo }
          }
        >
          Todos
        </BotaoFiltro>
        <BotaoFiltro
          onClick={() => setFiltroPorStatus(['Em aberto'])}
          style={
            filtroPorStatus.includes('Em aberto')
              ? { ...btnAtivo }
              : { ...btnInativo }
          }
        >
          Em aberto
        </BotaoFiltro>
        <BotaoFiltro
          onClick={() => setFiltroPorStatus(['Em andamento', 'Em atendimento'])}
          style={
            filtroPorStatus.includes('Em andamento')
              ? { ...btnAtivo }
              : { ...btnInativo }
          }
        >
          Em andamento
        </BotaoFiltro>
        <BotaoFiltro
          onClick={() =>
            setFiltroPorStatus(['Concluído', 'Cancelado', 'Fechado'])
          }
          style={
            filtroPorStatus.includes('Concluído')
              ? { ...btnAtivo }
              : { ...btnInativo }
          }
        >
          Concluído
        </BotaoFiltro>
      </BotoesContainer>
    </FiltrosContainer>
  );
};

export default FiltrosSolicitacoes;
